import { render, staticRenderFns } from "./Syllabus.vue?vue&type=template&id=f9a9f1ea&scoped=true"
import script from "./Syllabus.vue?vue&type=script&lang=js"
export * from "./Syllabus.vue?vue&type=script&lang=js"
import style0 from "./Syllabus.vue?vue&type=style&index=0&id=f9a9f1ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a9f1ea",
  null
  
)

export default component.exports